import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Store} from '@ngrx/store';
import {loadResearchPapers, retrieveResearchPaper} from './research-paper.actions';
import {loadScreeningSettings} from '../screening-settings/screening-settings.actions';
import {loadScreeningCriterias} from '../screening-criteria/screening-criteria.actions';
import {loadResearchKeywords} from '../research-keyword/research-keyword.actions';


export const researchPaperListResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  const projectIdString = route.parent!.parent!.paramMap.get('projectId');
  if (!projectIdString) {
    return false;
  }
  const projectId = +projectIdString;
  store.dispatch(loadResearchPapers({projectId: projectId}));
  store.dispatch(loadScreeningCriterias({projectId: projectId}));
  store.dispatch(loadResearchKeywords({projectId: projectId}));
  return true;
};


export const researchPaperDetailResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  const projectId = +route.parent!.paramMap.get('projectId')!;
  const paperId = +route.paramMap.get('paperId')!;

  store.dispatch(retrieveResearchPaper({projectId, id: paperId}));
  store.dispatch(loadScreeningSettings({projectId}));

  return true;
};
